import "es6-promise/auto";

import Vue from "vue";
import App from "./App.vue";
import store from "./store/store";
import * as types from "./store/types";
import * as constants from "./store/constants";
import router from "./router";

import axios from "axios";

const ENV_IS_PRODUCTION = () => {
  return window.location.hostname.match(/(local|^(127|192)\.(0|168)\.0\.1|staging)/) === null
}

// Vue GTag (Google Analytics Tracking)
import VueGtag from "vue-gtag";
if (ENV_IS_PRODUCTION()) {
  Vue.use(VueGtag, {
    config: {id: "UA-46851029-6"}
  }, router);
} else {
  console.log("ENV IS NOT PROD: Skipping GA")
}

// Vue GTM (Google Tag Manager) -- Not in use now
// import VueGtm from 'vue-gtm';
// Vue.use(VueGtm, {
//   id: 'GTM-PHDT9XD', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
//   enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
//   debug: true, // Whether or not display console logs debugs (optional)
//   loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
//   vueRouter: router, // Pass the router instance to automatically sync with router (optional)
//   // ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
// });

// Bootstrap
import { BootstrapVue } from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Style Imports
import 'vue2-datepicker/index.css';
import 'leaflet/dist/leaflet.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import "./assets/styles.less";


// Use-s
Vue.use(BootstrapVue);

Vue.config.productionTip = false;

Vue.prototype.$http = axios;
Vue.prototype.$types = types;
Vue.prototype.$constants = constants;

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
